<template>
    <a href="javascript:void(0);" @click="shareFb()">
        <svg version="1.1" id="share_icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
             x="0px" y="0px"
             viewBox="0 0 120 174.8" style="enable-background:new 0 0 120 174.8;" xml:space="preserve">
            <title>share3</title>
            <path class="st0" d="M59.6,119.8c-2.8,0-5-2.2-5-5V15.7L30,36.2c-2.1,1.8-5.3,1.5-7.1-0.6c-1.8-2.1-1.5-5.3,0.6-7L56.4,1.2
            c2.1-1.8,5.3-1.5,7,0.6c0.8,0.9,1.2,2.1,1.2,3.2v109.8C64.6,117.6,62.4,119.8,59.6,119.8z"/>
            <path class="st0" d="M92.5,37.4c-1.2,0-2.3-0.4-3.2-1.2L56.4,8.8c-2.2-1.7-2.5-4.9-0.8-7c1.7-2.2,4.9-2.5,7-0.8
            c0.1,0,0.1,0.1,0.2,0.2l32.9,27.4c2.1,1.8,2.4,4.9,0.6,7C95.4,36.7,94,37.4,92.5,37.4z"/>
            <path class="st0" d="M115,174.8H5c-2.8,0-5-2.2-5-5v-110c0-2.8,2.2-5,5-5h26.9c2.8,0,5,2.2,5,5c0,2.8-2.2,5-5,5H10v100h100v-100
            H87.4c-2.8,0-5-2.2-5-5s2.2-5,5-5H115c2.8,0,5,2.2,5,5v110C120,172.6,117.8,174.8,115,174.8z"/>
        </svg>
    </a>

</template>


<script>
    import facebookShare from '@/helpers/facebookShare'

    export default {
        methods: {
            shareFb() {
                this.dialog = facebookShare()
            }
        }
    }
</script>